























































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VBadge, VIcon, VChip } from 'vuetify/lib';
import { Utils } from '@/helper/utils';
import { PaginationModel } from '@/models/pagedlistmodel';
import { VAction } from '@/models/pagedlistmodel';

// TODO: Check
Vue.component('v-badge', VBadge as any);
Vue.component('v-icon', VIcon as any);
Vue.component('v-chip', VChip as any);
@Component({
  computed: {
    rowPerPageItems: {
      get() {
        const pagination = this.$props.pagination;
        if (
          (pagination && pagination.rowsPerPage === -1) ||
          this.isRowPerPageAll
        ) {
          this.isRowPerPageAll = true;
          return [5, 10, 15, 25, -1];
        } else if (
          this.allowRowPerPageItems &&
          this.allowRowPerPageItems.length
        ) {
          return this.allowRowPerPageItems;
        } else {
          return [5, 10, 15, 25];
        }
      },
      set(val) {
        return val;
      },
    },
    paginations: {
      get() {
        if (
          this.$props.enableCosmosPagination &&
          this.$props.showFirstLastPage
        ) {
          return this.getCosmosPagination(this.$props.pagination);
        } else {
          return this.$props.pagination;
        }
      },
      set(val) {
        const pagination = this.$props.pagination;
        if (pagination) {
          let isChange = false;
          if (!Utils.isEquivalent(pagination, val)) {
            isChange = true;
            this.isPaginationChange = true;
          }
          if (isChange) {
            this.gridOptionChange(val);
          }
        }
      },
    },
    enableSearch: {
      get() {
        if (this.search === undefined) {
          return true;
        } else {
          return this.search;
        }
      },
    },
    isskeletonLoading: {
      get() {
        if (this.$props.skeletonLoading === false) {
          return false;
        }
        return true;
      },
      set(val) {
        return val;
      },
    },
    sortBy: {
      get() {
        if (this.pagination) {
          if (this.$props.tag == 'tblReport') {
            return (this.paginations.sortBy = 'expenseId');
          } else if (this.$props.tag == 'tblCommunicationReport') {
            return (this.paginations.sortBy = 'email');
          } else if (this.$props.tag == 'tblDealPaymentReport') {
            return (this.paginations.sortBy = 'createdAt');
          } else if (this.$props.tag == 'tblDashboardText') {
            return (this.paginations.sortBy = 'createdAt');
          } else if (this.$props.tag == 'tblDealBlocks') {
            return (this.paginations.sortBy = 'sequenceNumber');
          } else if (this.$props.tag == 'tblDealBlockLineItems') {
            return (this.paginations.sortBy = 'sequenceNumber');
          } else {
            return this.paginations ? this.paginations.sortBy : '';
          }
        }
        return '';
      },
      set(val) {
        return val;
      },
    },
    skeletonLoader: {
      get() {
        const skeletonLoader = {
          'table-tbody': 'table-row-divider@5',
          'table-row-divider': 'table-row, divider',
          'table-row': 'table-cell@6',
        };
        if (this.$props.pagination) {
          if (this.$props.pagination.rowsPerPage === -1) {
            skeletonLoader['table-tbody'] = 'table-row-divider@10';
          } else {
            skeletonLoader['table-tbody'] =
              'table-row-divider@' + this.$props.pagination.rowsPerPage;
          }
        }
        if (this.$props.headers) {
          skeletonLoader['table-row'] =
            'table-cell@' + this.$props.headers.length;
        }
        return skeletonLoader;
      },
      set(val) {
        return val;
      },
    },
    cardListingData: {
      get() {
        return this.$props.items;

      },
      set(val) {
        return val;
      },
    },
  },
  components: {
    AppPagination: () => import('./app.pagination.vue'),
  },
  props: [
    'headers',
    'items',
    'search',
    'pagination',
    'loading',
    'actions',
    'itemKey',
    'isServerPagination',
    'hideActions',
    'enableCosmosPagination',
    'tag',
    'showFirstLastPage',
    'allowRowPerPageItems',
    'skeletonLoading',
    'isShownCard',
  ],
  watch: {
    loading(newVal: boolean) {
      if (newVal === true) {
        if (this.items) {
          this.items.splice(0, this.items.length);
        }
        if (this.isPaginationChange) {
          this.isPaginationChange = false;
        } else {
          if (this.pagination) {
            this.pagination.totalItems = 0;
          }
        }
      }
    },
    headers: {
      handler(newHeaders: any[]) {
        this.updateHeaderArray(newHeaders);
      },
      immediate: true,
      deep: true,
    },
    actions: {
      handler(actions) {
        this.updateActions(actions);
      },
      immediate: true,
      deep: true,
    },
  },
})
export default class AppGridComponent extends Vue {
  public headerArray = [];
  public actionArray = [];
  public $moment: any;
  public isRowPerPageAll: boolean = false;
  public selectAll: boolean = false;
  public items: any;
  public cardListData: any;
  public dataItems: any;
  public pagination: PaginationModel;
  public paginations: PaginationModel;
  public nextPage: boolean = false;
  public previousPage: boolean = false;
  public enableCosmosPagination: boolean;
  public isPaginationChange: boolean = false;
  public showFirstLastPage: boolean;
  public isServerPagination: boolean;
  public skeletonLoading: boolean;
  public skeletonLoader: any;
  public fab: boolean = false;
  public rowPerPage = 0;
  public isDefaultToogleNeedToExpanded: boolean = false;

  public updateHeaderArray(headers: any[]) {
    if (headers) {
      this.headerArray = [...headers];
      if (this.actionArray && this.actionArray.length > 0) {
        // Moving the action header item from the end to the beginning
        if (this.headerArray && !(this.headerArray[0].text == "Actions" || this.headerArray[0].text == "Action")) {
          let actionElement = this.headerArray.pop();
          this.headerArray.unshift(actionElement); // Insert it at the beginning
        }

      }
    }
  }
  public updateActions(action: any[]) {
    if (action && action.length > 0) {
      this.actionArray = action;
      this.updateHeaderArray(this.headerArray);
    }
  }

  public eval(object: any, prop: any): any {
    let value: any;
    window['item'] = object;
    // tslint:disable-next-line:no-eval
    value = prop.trim() != "" ? eval('item.' + prop.trim()) : "";
    window['item'] = null;
    return (value || this.$t('common.NA')).toString();
    // return (t(object, prop).safeObject || 'N/A').toString();
  }

  public dynamicFilter(filters, value, item): any {
    let newVal = value;
    if (filters && filters.length > 0) {
      filters.forEach((f) => {
        newVal = f(newVal, item);
      });
    }
    return newVal;
  }

  public dateFilter(val: any, format: string): any {
    if (val) {
      if (!this.$moment(val, this.$moment.ISO_8601).isValid()) {
        const date = new Date(val);
        if (this.isValidDate(date)) {
          val = date;
        }
      }
      if (format) {
        return this.$moment(val).format(format);
      } else {
        return this.$moment(val).format('lll');
      }
    }
  }

  public compileHtml(template): any {
    if (template) {
      return Vue.compile(template);
    } else {
      return Vue.compile(`<span></span>`);
    }
  }

  public onFieldIsChecked(field): void {
    if (this.items && this.items.length) {
      const filterItems = this.items.filter((item) => {
        return item[field] === true;
      });
      if (this.items && this.items.length === filterItems.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    }
  }

  public getValue(headerField, item) {
    if (!headerField) {
      return '';
    }

    if (typeof headerField === 'function') {
      return headerField(item);
    } else {
      return headerField;
    }
  }

  public getDynamicTemplate(item, data) {
    if (typeof item.template === 'function') {
      return this.compileHtml(item.template(data));
    } else {
      return this.compileHtml(item.template);
    }
  }

  public pageChanged(page: number) {
    if (this.paginations) {
      if (this.pagination.page != page) {
        this.paginations.page = page;
        this.isPaginationChange = true;
        this.gridOptionChange(this.paginations);
      }
    }
  }

  public gridOptionChange(pagination: PaginationModel) {
    if (this.isServerPagination) {
      this.items.splice(0, this.items.length);
    }
    this.$emit('page-change', pagination);
  }

  public toggleCheckbox(isChecked: boolean, header: any): void {
    if (this.items && this.items.length) {
      if (header && header.value) {
        this.items.forEach((item) => {
          if (isChecked) {
            item[header.value] = true;
          } else {
            item[header.value] = false;
          }
        });
      }
    }
  }

  public isValidDate(d: any): boolean {
    return d instanceof Date && !isNaN(d as any);
  }

  public updatePagination(paging: any): void {
    if (this.enableCosmosPagination && this.showFirstLastPage) {
      this.updateCosmosPagination(paging);
    } else {
      const pagination: any = {};
      if (paging) {
        pagination.rowsPerPage = paging.itemsPerPage;
        pagination.page = paging.page;
        pagination.sortBy =
          paging.sortBy && paging.sortBy.length ? paging.sortBy[0] : '';
        pagination.descending = paging.sortDesc.length
          ? paging.sortDesc[0]
          : paging.sortDesc;
        if (this.pagination) {
          pagination.search = this.pagination.search;
          pagination.totalItems = this.pagination.totalItems;
        }
      }
      this.paginations = pagination;
    }
  }

  public updateCosmosPagination(paging: any): void {
    const pagination: any = {};
    let isUpdated: boolean = false;
    if (paging) {
      pagination.rowsPerPage = paging.itemsPerPage;
      pagination.page = paging.page;
      pagination.sortBy =
        paging.sortBy && paging.sortBy.length ? paging.sortBy[0] : '';
      pagination.descending = paging.sortDesc.length
        ? paging.sortDesc[0]
        : paging.sortDesc;
      if (this.pagination) {
        pagination.search = this.pagination.search;
        pagination.totalItems = this.pagination.totalItems;
      }

      if (this.pagination.totalItems && paging.itemsPerPage) {
        const isLast = paging.page - this.pagination.page === 2;
        if (isLast) {
          pagination.page = -1;
          isUpdated = true;
        }
      }
    }
    if (
      (pagination.page !== -1 || isUpdated) &&
      !this.paginations['isLastPage']
    ) {
      this.paginations = pagination;
    }
    this.paginations['isLastPage'] = false;
    this.$props.pagination.isLastPage = false;
  }

  public getCosmosPagination(paging: PaginationModel): PaginationModel {
    const pagination: PaginationModel = new PaginationModel();
    pagination.sortBy = paging.sortBy;
    pagination.descending = paging.descending;
    pagination.rowsPerPage = paging.rowsPerPage;
    pagination.search = paging.search;
    pagination.page = paging.page;
    pagination['isLastPage'] = paging['isLastPage'];
    if (paging.totalItems && paging.rowsPerPage) {
      const pages = Math.ceil(paging.totalItems / paging.rowsPerPage);
      if (pages > 1 && paging.totalItems > paging.page * paging.rowsPerPage) {
        pagination.totalItems = paging.totalItems + (paging.rowsPerPage + 1);
      } else {
        pagination.totalItems = paging.totalItems;
      }
    }
    return pagination;
  }

  public toggleExpanded(item): void {
    if (item && typeof item.expand === 'function') {
      if (item.isExpanded) {
        item.expand(false);
      } else {
        item.expand(true);
      }
    }
  }
  // code for default toogle expanded
  public isToogleExpanded(item): void {
    if (item && typeof item.expand === 'function' && !this.isDefaultToogleNeedToExpanded) {
      item.isExpanded = true;
      item.expand(true);
      this.isDefaultToogleNeedToExpanded = true;
    }
  }

  public onPageCount(totalPage: number) {
    if (!this.isServerPagination && !this.enableCosmosPagination) {
      if (this.paginations) {
        if (this.paginations.page < 1 || this.paginations.page == undefined || !this.paginations.page) {
          this.paginations.page = 1;
        }
        this.paginations.totalItems = totalPage * this.paginations.rowsPerPage;
      }
    }
  }

  public isActionLoading(action: VAction, item: any): boolean {
    if (action) {
      if (typeof action.loading === 'function') {
        return action.loading(item, action);
      }
      return action.loading;
    }
    return false;
  }
}
